/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
const t={groupSeparator:1,action:{s:32,m:48,l:64},splitButtonPart:{horizontal:{s:16,m:16,l:24},vertical:{s:16,m:24,l:40}}},o={splitButton:{horizontal:"chevron-down",vertical:"ellipsis"},overflow:"ellipsis"};function l(t,o){return t.vnodeSelector===o?[t]:t.children?.flatMap((t=>l(t,o)))??[]}export{o as Icons,t as WellKnownSizes,l as findMatchingChildren};
